import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import AppRouting from "./pages/routes";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Navbar from "./components/Navbar/Navbar.componet";
import Notification from "./components-new/notification/Notification";
import Navigation from "./components/CodeGen/TopNav";
import App2 from "./app-2/App";
import ApiHandoffGate from "./pages-new/API/ApiHandoffGate";
import { usePageTitle } from "./hooks/usePageTitle";
import "./App.style.scss";
import GlobalSlowLoader from "./pages-new/SlowLoader";
import { VariableProvider } from "./context/VariableContext";

const AppContent = () => {
  const location = useLocation();
  const isSidebarOpen = useSelector((state) => state.SiteSettings.issidebaropen);
  let isCodeGen = false;

  // Use the page title hook
  usePageTitle();

  let isPaymentCompleted = false;
  try {
    const userDetails = localStorage.getItem("userDetail");
    if (userDetails) {
      const user = JSON.parse(userDetails);
      isCodeGen = user?.company?.logintype === "codegen" || user?.codegen === "codegen";
      isPaymentCompleted =
        user?.company?.plan && user?.company?.plan?.available_credits > 0 ? true : false;
    }
  } catch (error) {
    console.error("Error parsing user details from localStorage:", error);
  }

  const isUsingOldLayout = !location.pathname.startsWith("/new") && !isCodeGen;
  const isLoginPage = location.pathname === "/LoginPage" || location.pathname === "/LoginPage/";
  const isSignUpPage = location.pathname.startsWith("/SignUpPage");
  const isForgotPasswordPage =
    location.pathname === "/ForgotPasswordPage" || location.pathname === "/ForgotPasswordPage/";
  const isApp2Route = location.pathname.startsWith("/api");
  const isPublicRoute =
    location.pathname.includes("/dashboard/app/companyId/") ||
    location.pathname.startsWith("/public/results/") ||
    location.pathname.startsWith("/dashboard/app/productId");

  const isAuthRoute =
    location.pathname.includes("/LoginPage") ||
    location.pathname.includes("/SignUpPage") ||
    location.pathname.includes("/ForgotPasswordPage");

  const isProtectedRoute = !isAuthRoute && !isPublicRoute && !location.pathname.startsWith("/api");

  const navigate = useNavigate();
  // Back Button Refresh Attack guard
  useEffect(() => {
    if (isProtectedRoute) {
      const userDetails = localStorage.getItem("userDetail");
      if (!userDetails) {
        navigate("/LoginPage", { replace: true });
      }
    }
  }, [location.pathname, isProtectedRoute, navigate]);

  const shouldRenderNavigation =
    isCodeGen && !isLoginPage && !isSignUpPage && !isForgotPasswordPage && isPaymentCompleted;

  const dynamicStyles = (theme) => ({
    marginTop: isApp2Route
      ? "0"
      : isLoginPage || isSignUpPage || isCodeGen || isForgotPasswordPage || isPublicRoute
        ? "0"
        : "40px",
    marginLeft: isApp2Route || isPublicRoute || isAuthRoute ? "0" : isUsingOldLayout ? "64px" : "0",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(isSidebarOpen &&
      isUsingOldLayout && {
      marginLeft: "248px",
      width: `calc(100% - 248px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  });

  return (
    <>
      {/* Hide Navbar and Navigation for /app2 routes and public routes */}
      {!isApp2Route && isUsingOldLayout && !isCodeGen && !isPublicRoute && <Navbar />}
      {!isApp2Route && shouldRenderNavigation && <Navigation />}
      <Box className={"test"} sx={(theme) => dynamicStyles(theme)} open={isSidebarOpen}>
        <Routes>
          <Route path="/*" element={<AppRouting />} />
          <Route
            path="/api/*"
            element={
              <ApiHandoffGate>
                <VariableProvider>
                  <App2 />
                </VariableProvider>
              </ApiHandoffGate>
            }
          />
        </Routes>
      </Box>
    </>
  );
};

const App = () => {
  return (
    <div className="App">
      <Router>
        <GlobalSlowLoader />
        <AppContent />
        <Notification />
      </Router>
    </div>
  );
};

export default App;
